const defaultState = {
    initialLoading: true,
    loading: false,
    error: false,
    totals: 0,
    page: 0,
    pageCount: 10,
    isActiveSearch: false,
    data: [],
    category: {
        loading: true,
        error: null,
        data: {
            id: null,
            name: null,
        },
        actions: {
            save: {
                id: null,
                loading: false,
                success: false,
                error: null,
            },
        }
    },
};

export default function reducer(state = defaultState, action) {
    switch (action.type) {
        case 'CATEGORIES_FETCH_CATEGORIES_START':
            return Object.assign({}, state, {
                initialLoading: state.initialLoading || state.error ? true : false,
                loading: true,
                error: false,
                isActiveSearch: action.payload.isActiveSearch,
            })

        case 'CATEGORIES_FETCH_CATEGORIES_SUCCESS':
            return Object.assign({}, state, {
                initialLoading: false,
                loading: false,
                data: [].concat(action.payload.categories),
                totals: action.payload.totals,
                pageCount: action.payload.pageCount,
                page: action.payload.pageCount * (action.payload.page) >= action.payload.totals ? action.payload.page - 1 : action.payload.page
            })

        case 'CATEGORIES_FETCH_CATEGORIES_FAIL':
            return Object.assign({}, state, {
                initialLoading: false,
                loading: false,
                error: true,
            })

        case 'CATEGORIES_FETCH_CATEGORY_START':
            return Object.assign({}, state, {
                category: Object.assign({}, state.category, {
                    loading: true,
                })
            })

        case 'CATEGORIES_FETCH_CATEGORY_SUCCESS':
            return Object.assign({}, state, {
                category: Object.assign({}, state.category, {
                    loading: false,
                    data: {
                        id: action.payload.category.id,
                        name: action.payload.category.nombre,
                    }
                })
            })

        case 'CATEGORIES_FETCH_CATEGORY_FAIL':
            return Object.assign({}, state, {
                category: Object.assign({}, state.category, {
                    loading: false,
                    error: true,
                })
            })

        case 'CATEGORIES_SAVE_CATEGORY_START':
            return Object.assign({}, state, {
                category: Object.assign({}, state.category, {
                    actions: Object.assign({}, state.category.actions, {
                        save: {
                            id: action.payload && action.payload.patch && action.payload.id ? action.payload.id : null,
                            loading: true,
                            success: false,
                            error: null,
                        }
                    })
                })
            })

        case 'CATEGORIES_SAVE_CATEGORY_SUCCESS':
            const data = action.payload && action.payload.patch && action.payload.id ? state.data.map((item) => {
                return item.id !== action.payload.id ? item : { ...item, ...action.payload.data }
            }) : null

            return Object.assign({}, state, {
                data: action.payload && action.payload.patch && action.payload.id ? [].concat(data) : state.data,
                category: Object.assign({}, state.category, {
                    actions: Object.assign({}, state.category.actions, {
                        save: {
                            id: null,
                            loading: true,
                            success: true,
                            error: null,
                        }
                    })
                })
            })

        case 'CATEGORIES_SAVE_CATEGORY_FAIL':
            return Object.assign({}, state, {
                category: Object.assign({}, state.category, {
                    actions: Object.assign({}, state.category.actions, {
                        save: {
                            id: null,
                            loading: false,
                            success: false,
                            error: true,
                        }
                    })
                })
            })

        case 'CATEGORIES_SAVE_CATEGORY_RESET':
            return Object.assign({}, state, {
                category: Object.assign({}, state.category, {
                    actions: Object.assign({}, state.category.actions, {
                        save: defaultState.category.actions.save,
                    })
                })
            })

        case 'CATEGORIES_FORM_PROPERTY_VALUE_SET':
            return Object.assign({}, state, {
                category: Object.assign({}, state.category, {
                    data: Object.assign({}, state.category.data, {
                        [action.payload.property]: action.payload.value
                    })
                })
            })

        case 'CATEGORIES_CATEGORY_RESET':
            return Object.assign({}, state, {
                category: Object.assign({}, defaultState.category)
            })

        case 'CATEGORIES_RESET':
            return  Object.assign({}, state, defaultState)

        default:
            return state;
    }
}
